
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 66 47","fill":"currentColor","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#upwork","x":".5","y":".5"}}),_c('symbol',{attrs:{"id":"upwork","overflow":"visible"}},[_c('path',{attrs:{"d":"M49.487 3.872c-6.86.033-12.074 4.57-14.026 11.8-3.275-5.04-5.83-10.805-7.295-15.672l-7.22.034.1 19.138a6.861 6.861 0 01-13.721.064L7.224.099 0 .134l.1 19.14c.028 7.941 6.374 14.234 14.14 14.194s14.055-6.386 14.02-14.33l-.015-3.25c1.455 2.88 3.275 5.95 5.275 8.65l-4.415 21.144 7.4-.034 3.18-15.362c2.896 1.793 6.15 2.86 9.94 2.842C57.57 33.083 64.04 26.555 64 18.238c-.036-7.946-6.568-14.413-14.512-14.377zm.113 21.846c-2.888.013-5.782-1.236-8.138-3.213l.708-2.9v-.182c.528-3.074 2.126-8.316 7.542-8.34a7.244 7.244 0 017.257 7.188c-.163 4.153-3.577 7.42-7.37 7.437z","stroke":"none","fill-rule":"nonzero"}})])])
          )
        }
      }
    